export default __webpack_public_path__ + "static/media/z040ma0b.08b7f4c3.mp3";